const SET_GLOBAL_DATA = 'alerts/SET_GLOBAL_DATA';
const CUSTOMER_DATA = 'alerts/CUSTOMER_DATA';
const DISTRIBUTOR_DATA = 'alert/DISTRIBUTOR_DATA';
const SET_PREVGLOBAL_DATA = 'alerts/SET_PREVGLOBAL_DATA';

export {
    SET_GLOBAL_DATA,
    CUSTOMER_DATA,
    DISTRIBUTOR_DATA,
    SET_PREVGLOBAL_DATA
};